export const formatters = {
  lowercase: (value: string, lng: string, options: any) => value.toLowerCase()
};
